import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getPersonById } from '../components/Person/actions';

function usePersonDetails(person) {
  const dispatch = useDispatch();

  const [personDetails, setPersonDetails] = useState(person);

  const getUserDetails = async () => {
    const res = await getPersonById(dispatch, person.id);
    res?.id && setPersonDetails(res);
  };

  useEffect(() => {
    person?.id && getUserDetails();
  }, []);

  return personDetails || {};
}

export default usePersonDetails;
